// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartPropsSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { action } from 'mobx';
import { isUndefined, get } from 'lodash/fp';
import cfgFactories from 'share/factories/Izenda.ReportPartStyleConfigurationFactories';

/**
 * Create the Property editor configuration of the report part. This configuration defines
 * how Property editor components shoulw be arranged, rendered and reacted to user change.
 * @param {Object} reportDesignerModel Report designer model
 * @param {Object} reportPartDetails Report part detail
 * @param {Object} fieldStore Field store
 */
export default (reportDesignerModel: Object, reportPartDetails: Object, fieldStore: Object) => {
  ensure(!!reportDesignerModel, 'reportDesignerModel must be set');

  // Pick the report part type and report part style
  const reportPartStyle = get('reportPartContent.reportPartStyle', reportPartDetails);
  const reportPartType = reportPartDetails.type;

  const {
    propertyWidgets,
    propertySchema,
    propertyMappingProps,
    propertyMappingSource,
    propertyValueChange
  } = cfgFactories.getConfiguration(reportPartType, reportPartStyle);

  return {
    definedSchema: propertySchema,
    widgets: propertyWidgets,
    mappingProps: propertyMappingProps(reportPartDetails, fieldStore),
    source: {},
    mappingSource: propertyMappingSource(reportPartDetails, fieldStore),
    onChangeValue: (
      schemaData: any,
      changedKey: string,
      changedKeyPath: any,
      changedValue: any,
      changedOthersInfo: any
    ) =>
      propertyValueChange(reportPartDetails, fieldStore)(
        schemaData,
        changedKey,
        changedKeyPath,
        changedValue,
        changedOthersInfo
      ).then(({ needToUpdate, chartProperties }) => {
        ensure(
          !isUndefined(needToUpdate),
          'onChangeValue handler must return object containing a boolean needToUpdate property'
        );

        return needToUpdate ? fieldStore.needUpdatePreview(reportPartDetails) : Promise.resolve(true);
      })
  };
};



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/Izenda.ReportPartPropsSchema.js